export const PROFILE_SCOPE_SEARCH_PARAM = "profileScope"
export const PROFILE_SCOPE_WITH_CHILDREN = "with-children"
export const PROFILE_SCOPE_LOCATION_ONLY = "location-only"
const PERIOD_SORT = {
    Hour: 1,
    Day: 24,
    Week: 24 * 7,
    Month: 24 * (365 / 12),
    Year: 24 * 365,
}
const PERIOD_INITIAL_SORT = {
    H: PERIOD_SORT.Hour,
    D: PERIOD_SORT.Day,
    W: PERIOD_SORT.Week,
    M: PERIOD_SORT.Month,
    Y: PERIOD_SORT.Year,
}

export function getAssetProfileTableStats(stats, scope = PROFILE_SCOPE_WITH_CHILDREN) {
    if (normaliseAssetProfileScope(scope) !== PROFILE_SCOPE_LOCATION_ONLY) return stats
    if (!stats?.stats?.schedules || !stats?.stats?.periods) return stats

    return {
        ...stats,
        all: stats.stats.schedules,
        periods: sortPeriods(stats.stats.periods),
    }
}

export function normaliseAssetProfileScope(scope) {
    if (scope === PROFILE_SCOPE_LOCATION_ONLY) return PROFILE_SCOPE_LOCATION_ONLY
    return PROFILE_SCOPE_WITH_CHILDREN
}

export function getAssetProfileScopeLabel(scope) {
    if (normaliseAssetProfileScope(scope) === PROFILE_SCOPE_LOCATION_ONLY) return "Location only"
    return "Location and below"
}

function sortPeriods(periods) {
    return [...periods].sort(comparePeriods)
}

function comparePeriods(left, right) {
    return getPeriodSortValue(left) - getPeriodSortValue(right)
}

function getPeriodSortValue(period) {
    const periodName = normalisePeriodName(period.period)
    if (PERIOD_SORT[periodName]) return PERIOD_SORT[periodName] * (period.interval || 1)
    return getFrequencySortValue(period.frequency)
}

function normalisePeriodName(period) {
    if (!period) return ""
    const trimmed = String(period).trim()
    return `${trimmed[0]?.toUpperCase() ?? ""}${trimmed.slice(1).toLowerCase()}`.replace(/s$/, "")
}

function getFrequencySortValue(frequency) {
    const [, interval, period] = String(frequency ?? "").match(/^(\d+)([A-Z])$/) ?? []
    return (PERIOD_INITIAL_SORT[period] ?? 0) * +(interval || 1)
}
